import { createContext, useContext, useMemo, useState } from 'react';

interface ActiveMobileWidgetContextValue {
  activeMobileWidgetId: string | null;
  setActiveMobileWidgetId: (id: string | null) => void;
}

const ActiveMobileWidgetContext = createContext<ActiveMobileWidgetContextValue>({
  activeMobileWidgetId: null,
  setActiveMobileWidgetId: () => {},
});

/**
 * Shares which dashboard widget is currently visible on the mobile single-widget
 * host with sibling trees that need it (e.g. the deep-dive bottom bar, mounted
 * separately via SidePanelShell) — plain state alone wouldn't cross that boundary,
 * and localStorage doesn't notify same-tab listeners.
 */
export function ActiveMobileWidgetProvider({ children }: { children: React.ReactNode }) {
  const [activeMobileWidgetId, setActiveMobileWidgetId] = useState<string | null>(null);
  const value = useMemo(
    () => ({ activeMobileWidgetId, setActiveMobileWidgetId }),
    [activeMobileWidgetId],
  );

  return (
    <ActiveMobileWidgetContext.Provider value={value}>
      {children}
    </ActiveMobileWidgetContext.Provider>
  );
}

export function useActiveMobileWidget() {
  return useContext(ActiveMobileWidgetContext);
}
